import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckboxGroup,
  InputText,
  Radio,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../Shared';

import {
  checkboxGroupTheme,
  inputTheme,
  radioTheme,
} from '../../../lib';


const formName = 'Frosted Window Films';

const defaultValues = {
  'Window-size': '',
  'Coverage-percentage': '',
  'Features': '',
  'Installation-required': '',
};

const fields = [
  'Window-size',
  'Coverage-percentage',
  'Features',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Window-size'
        inputTextName='Window-size'
        register={register}
        formState={formState}
        label='Size of window(s)'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Coverage-percentage'
        inputTextName='Coverage-percentage'
        register={register}
        formState={formState}
        label='Approximate coverage percentage'
        theme={inputTheme}
      />

      <CheckboxGroup
        checkboxGroupId='Features'
        checkboxGroupName='Features'
        legend='Features'
        options={[
          { value: 'full-flood',label: 'Full flood' },
          { value: 'printed-graphics',label: 'Printed graphics' },
          { value: 'die-cut',label: 'Die cut graphics/design' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={{checkboxGroupTheme}}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Do you require installation?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
